import React from 'react';

import { Card } from '@xingternal/card';
import { BodyCopy, Headline } from '@xingternal/typography';

import { SimilarJobVisibleJobFragment as SimilarJobType } from '@/graphql/generated';
import { LineClampOne, LineClampTwo } from '@/styles/line-clamp';

import * as S from './job-card.styles';

type Props = {
  job: SimilarJobType;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  url: string;
  'data-testid': string;
  'data-cy': string;
};

export const JobCard: React.FC<Props> = ({
  job,
  onClick,
  onMouseDown,
  onMouseLeave,
  url,
  'data-testid': dataTestId,
  'data-cy': testCyId,
}) => {
  const { companyInfo, title, location } = job;
  const city = location?.city;
  const companyName = companyInfo?.companyNameOverride ?? '';
  const companyLogos = companyInfo?.company?.logos ?? {};

  return (
    <Card
      to={url}
      onClick={onClick}
      linkProps={{ onMouseDown, onMouseLeave }}
      data-testid={dataTestId}
      data-cy={testCyId}
    >
      <S.ProfileImage type="company" profileName={companyName} size="medium" src={companyLogos.x1 ?? ''} />
      <S.Title as={Headline} size="medium" forwardedAs="h3">
        {title}
      </S.Title>
      {city ? (
        <LineClampOne as={BodyCopy} size="medium" lineHeight="default" noMargin>
          {city}
        </LineClampOne>
      ) : null}
      <LineClampTwo as={BodyCopy} size="medium" lineHeight="default" noMargin>
        {companyName}
      </LineClampTwo>
    </Card>
  );
};
